import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import { Row, Col, Upload, Button, DatePicker } from "antd";
import styled from "styled-components";
import { Form, Input, Select } from "antd";
import { UploadOutlined, RightOutlined } from "@ant-design/icons";
import { Checkbox } from "antd";
import { message } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import PeopleMenu from "../../Pages/People/Peoplemenu";
import EditForm from "../../Pages/People/Editform";
import PostUpdateData from "../../../hooks/postUpdate";
import FetchData from "../../../hooks/FetchData";
import {  useSelector } from "react-redux";


const { Option } = Select;

const Uploadcontainer = styled.div`
  .document_uploader.ant-upload-wrapper .ant-upload-select {
    width: 100%;
  }
  .Click_to_Upload {
    width: 100%;
    background-color: #c2fae5 !important;
    border: none !important;
  }
  .checkbox_container {
    height: 100px;
    align-items: center;
    display: flex;
    width: 100%;
    justify-content: space-between;
  }

  .checkbox_container .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #6ada89 !important;
    border-color: gray !important;
  }
  .btn_for_create_container {
    display: flex;
    justify-content: end;
    width: 100%;
    gap: 30px;
  }
  .cancel__btn {
    padding: 4px 40px 4px 40px !important;
    border: 1px solid #737684 !important;
    background-color: white !important;
    color: black;
  }
  .cancel_create_btn {
    padding: 4px 40px 4px 40px !important;
    background-color: #c2fae5 !important;
    color: black;
  }
  .people_container {
    display: flex;
    gap: 5px;
    margin: 0px 0px 30px 0px;
    align-items: center;
  }
  .people_back_button {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 0;
    border: 0;
    background: transparent;
    color: #636980;
    font-family: sans-serif;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
  }
  .people_subheading {
    font-family: sans-serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 20.83px;
    text-align: left;
  }
  .people_icon {
    color: #636980;
    transform: scale(0.9);
  }
  .people_add_checkbox {
    text-align: left;
  }
  .Exclude_from_all {
    text-align: left;
  }
  .document_uploader:where(.css-dev-only-do-not-override-1hpnbz2).ant-upload-wrapper .ant-upload-select{
    width: 100%;
  }
`;

const Createformpeople = ({endPoint, method, obj}) => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const Location = useLocation();
  const employeeDetails = Location.state || {};
  const userInfo = useSelector(function(state){
return state.authTracking.userInfo
  })
  console.log(userInfo , 'userInfo')
  console.log("employeeDetails-->", employeeDetails.Emailid);
  const onChange = (checkedValues) => {
    console.log("checked = ", checkedValues);
  };

  // Custom fields defined in Settings > People > Custom Field
  // (tymeplushrlmsuserfields) - rendered dynamically below the fixed
  // fields, values saved per-person into tymeplushrlmspeoplecustomvalues.
  const [customFields, setCustomFields] = useState([]);

  useEffect(() => {
    const fetchCustomFields = async () => {
      if (!userInfo?.clientId) return;
      try {
        const response = await FetchData({
          endPoint: `/settings/getuserfield/${userInfo.clientId}`,
        });
        if (response?.statusCode === 200 && Array.isArray(response?.response)) {
          setCustomFields(response.response);
        }
      } catch (error) {
        console.error("Error fetching custom fields:", error);
      }
    };
    fetchCustomFields();
  }, [userInfo?.clientId]);

  const isEditMode = !!employeeDetails?.people_id;

  const onFinish = async (values) => {

    const custom_fields = {};
    customFields.forEach((field) => {
      custom_fields[field.field_id] = values[`custom_${field.field_id}`];
    });

    const payload = {
            first_name:values.Firstname,
            last_name:values.Lastname,
            email:values.email,
            bio:values.Bio,
            user_name:values.Username,
            // Form.Item is name="Password" (capital P) - values.password
            // was always undefined, so no password was ever saved.
            password:values.Password,
            country:values.country,
            grade_code:values.gradeCode,
            grade:values.GradeCode,
            competency:values.competencey  ,
            service_line:values.Serviceline,
            departrment:values.department,
            time_zone:values.timezone,
            peopel_type:values.peopletype,
            upload_profile:values.document,
            active: !!values.Activeagreement,
            // A checkbox toggling a timestamp column, not a boolean -
            // matches the pattern already used in Users/AddUser.js.
            deactivated_at: values.Deactivateagreement ? new Date().toISOString() : null,
            exclude_notification: !!values.Excludenotifications,
            custom_fields,
            }

    try {
      const response = isEditMode
        ? await PostUpdateData({
            endPoint: `/people/updateuser/${userInfo.clientId}/${employeeDetails.people_id}`,
            method: "PATCH",
            obj: { ...payload, created_at: employeeDetails.created_at || null },
          })
        : await PostUpdateData({
            endPoint: `/people/adduser/${userInfo.clientId}`,
            method: "POST",
            obj: payload,
          });

      const isSuccess = isEditMode
        ? response?.status === 200 || response?.statusCode === 200
        : response?.statusCode === 201;

      if (isSuccess) {
        message.success(isEditMode ? "Person updated successfully" : "Person created successfully");
        navigate("/people");
      } else {
        message.error("Something went wrong while saving");
      }
    } catch (error) {
      console.error("Error while saving person:", error);
      message.error("Something went wrong while saving");
    }
  };






  

  function handleclicknavigate() {
    navigate("/people");
  }

  const [description, setDescription] = useState(
    "Description must be at least 50 characters deescription must beat least 50 characters description must be at least 50 characters"
  );

  useEffect(
    function () {
      if (!isEditMode) return;
      form.setFieldsValue({
        Firstname: employeeDetails?.first_name,
        Lastname: employeeDetails?.last_name,
        email: employeeDetails?.email,
        Bio: employeeDetails?.bio,
        Username: employeeDetails?.user_name,
        Password: employeeDetails?.password,
        country: employeeDetails?.country,
        gradeCode: employeeDetails?.grade_code,
        GradeCode: employeeDetails?.grade,
        competencey: employeeDetails?.competency,
        Serviceline: employeeDetails?.service_line,
        department: employeeDetails?.departrment,
        timezone: employeeDetails?.time_zone,
        peopletype: employeeDetails?.peopel_type,
        document: employeeDetails?.upload_profile,
        Activeagreement: !!employeeDetails?.active,
        Deactivateagreement: !!employeeDetails?.deactivated_at,
        Excludenotifications: !!employeeDetails?.exclude_notification,
      });
    },
    [employeeDetails, isEditMode]
  );

  // Pre-fill saved custom field values on edit. They come back as text
  // (employeeDetails.custom_values), so each is turned back into what its
  // input expects - a boolean for checkboxes, a date for date pickers.
  useEffect(() => {
    if (!isEditMode || customFields.length === 0) return;
    const savedValues = employeeDetails?.custom_values || [];
    const formValues = {};
    customFields.forEach((field) => {
      const saved = savedValues.find((item) => String(item.field_id) === String(field.field_id));
      if (!saved) return;
      if (field.field_type === "checkbox") {
        formValues[`custom_${field.field_id}`] = saved.value === "true";
      } else if (field.field_type === "date") {
        const date = dayjs(saved.value);
        formValues[`custom_${field.field_id}`] = date.isValid() ? date : undefined;
      } else {
        formValues[`custom_${field.field_id}`] = saved.value;
      }
    });
    form.setFieldsValue(formValues);
  }, [employeeDetails, isEditMode, customFields, form]);



  return (
    <>
      <Uploadcontainer>
        <Row gutter={[16, 16]}>
          <Col xl={12} xs={24} sm={24}>
            <div className="people_container">
              <button
                type="button"
                className="people_back_button"
                onClick={handleclicknavigate}
              >
                People <RightOutlined aria-hidden="true" />
              </button>
              <p className="people_subheading">
                {Object.keys(employeeDetails).length
                  ? employeeDetails?.name
                  : "Creating people "}
              </p>
            </div>
          </Col>
        </Row>
      </Uploadcontainer>

      <Uploadcontainer>
        <Form
          form={form}
          name="custom_form"
          layout="vertical"
          onFinish={onFinish}
          autoComplete="off"
        >
          <Row gutter={12}>
            <Col sm={24} xl={12}>
              <Form.Item
                className="text-left"
                name="Firstname"
                label="Firstname"
                // min-length only enforced on create - real existing people
                // (e.g. names under 5 chars) would otherwise be uneditable.
                rules={[
                  {
                    required: true,
                    message: "Please input your first name!",
                  },
                  ...(isEditMode
                    ? []
                    : [{ min: 5, message: "Firstname must be at least 5 characters!" }]),
                  { whitespace: true },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xl={12} sm={24}>
              <Form.Item
                className="text-left"
                name="Lastname"
                label="Lastname"
                rules={[
                  {
                    required: true,
                    message: "Please input your Last name!",
                  },
                  ...(isEditMode
                    ? []
                    : [{ min: 5, message: "Lastname must be at least 5 characters!" }]),
                ]}
              >
                <Input />
              </Form.Item>
            </Col>

            <Col xl={12} sm={24}>
              <Form.Item
                className="text-left"
                name="email"
                label="Email"
                layout="vertical"
                rules={[
                  {
                    required: true,
                    message: "Please input your email!",
                  },
                  {
                    type: "email",
                    message: "Please enter a valid email address!",
                  },
                ]}
              >
                <Input type="email" />
              </Form.Item>
            </Col>
            <Col xl={12} sm={24}>
              <Form.Item
                className="text-left"
                name="Bio"
                label="Bio"
                // The 50-char-minimum/required rules only make sense when
                // creating someone new - they made editing any existing
                // person with a short or empty bio (which is most of the
                // real data) impossible, since Save would silently fail
                // client-side validation with no obvious feedback.
                rules={[
                  ...(isEditMode
                    ? []
                    : [
                        { required: true, message: "Please provide a description!" },
                        {
                          min: 50,
                          message: "Description must be at least 50 characters.",
                        },
                      ]),
                  {
                    max: 500,
                    message: "Description must not exceed 500 characters.",
                  },
                  {
                    pattern: /^[a-zA-Z0-9\s.,'-]*$/,
                    message:
                      "Description can only include letters, numbers, and common punctuation.",
                  },
                ]}
              >
                <Input placeholder="" type="text" />
              </Form.Item>
            </Col>

            <Col xl={12} sm={24}>
              <Form.Item
                className="text-left"
                name="Username"
                label="Username"
                layout="vertical"
                rules={[
                  { required: true, message: "Please input your username!" },
                  ...(isEditMode
                    ? []
                    : [
                        {
                          pattern: /^[a-zA-Z0-9_]+$/,
                          message:
                            "Username can only contain letters, numbers, and underscores.",
                        },
                        {
                          min: 3,
                          message: "Username must be at least 3 characters long.",
                        },
                      ]),
                ]}
              >
                {/* Field-level autocomplete - browsers ignore the form's
                    autoComplete="off" for a username + password pair and
                    autofill the admin's own saved login into it. */}
                <Input autoComplete="off" />
              </Form.Item>
            </Col>
            <Col xl={12} sm={24}>
              <Form.Item
                className="text-left"
                name="Password"
                label="Password"
                // Same reasoning as Bio: real existing passwords (e.g. "123456")
                // don't meet this bar, so enforcing it on edit blocked saving
                // any unrelated change unless the password was also rewritten.
                rules={
                  isEditMode
                    ? []
                    : [
                        { required: true, message: "Please input your Password!" },
                        {
                          min: 8,
                          message: "Password must be at least 8 characters long.",
                        },
                        {
                          max: 20,
                          message: "Password must not exceed 20 characters.",
                        },
                        {
                          validator: (_, value) =>
                            !value || !/\s/.test(value)
                              ? Promise.resolve()
                              : Promise.reject("Password must not contain spaces."),
                        },
                      ]
                }
              >
                {/* "new-password" = setting a password for someone else, so
                    browsers don't fill in (or offer to save) the admin's own. */}
                <Input.Password type="password" autoComplete="new-password" />
              </Form.Item>
            </Col>

            <Col xl={12} sm={24}>
              <Form.Item
                className="text-left"
                name="country"
                label="Country"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select placeholder="" allowClear>
                  <Option value="kenya">Kenya</Option>
                  <Option value="Uganda">Uganda</Option>
                  <Option value="Africa">Africa</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col xl={12} sm={24}>
              <Form.Item
                className="text-left"
                name="gradeCode"
                label="Grade code"
                rules={[
                  {
                    required: true,
                  },
                  { message: "please select a gradeCode" },
                ]}
              >
                <Select placeholder="" allowClear>
                  <Option value="A1">A1</Option>
                  <Option value=""></Option>
                  <Option value=""></Option>
                </Select>
              </Form.Item>
            </Col>

            <Col xl={12} sm={24}>
              <Form.Item
                className="text-left"
                name="GradeCode"
                label="Grade"
                rules={[
                  {
                    required: true,
                  },
                  { message: "please select a Gradecode" },
                ]}
              >
                <Select placeholder="" allowClear>
                  <Option value="Audit">Audit</Option>
                  <Option value=""></Option>
                  <Option value=""></Option>
                </Select>
              </Form.Item>
            </Col>
            <Col xl={12} sm={24}>
              <Form.Item
                className="text-left"
                name="competencey"
                label="Competencey"
                rules={[
                  {
                    required: true,
                  },
                  { message: "please select a competencey" },
                ]}
              >
                <Select placeholder="" allowClear>
                  <Option value="Audit">Audit</Option>
                  <Option value="Uganda">Uganda</Option>
                  <Option value="Africa">Africa</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col xl={12} sm={24}>
              <Form.Item
                className="text-left"
                name="Serviceline"
                label="Service Line"
                rules={[
                  {
                    required: true,
                    message: "Please input your first name!",
                  },
                  ...(isEditMode ? [] : [{ min: 5 }, { max: 50 }]),
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xl={12} sm={24}>
              <Form.Item
                className="text-left"
                name="department"
                label="Department"
                rules={[
                  {
                    required: true,
                    message: "Please input your first name!",
                  },
                  ...(isEditMode ? [] : [{ min: 5 }, { max: 50 }]),
                ]}
              >
                <Input />
              </Form.Item>
            </Col>

            <Col xl={12} sm={24}>
              <Form.Item
                className="text-left"
                name="timezone"
                label="Timezone"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select placeholder="" allowClear>
                  <Option value="GMT + 0:00">(GMT + 0:00)</Option>
                  <Option value="">(GMT + 0:01)</Option>
                  <Option value="">(GMT + 0:02)</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col xl={12} sm={24}>
              <Form.Item
                className="text-left"
                name="peopletype"
                label="Peopletype"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select placeholder="" allowClear>
                  <Option value="Learner-Type">Learner-Type</Option>
                  <Option value="">Learner </Option>
                  <Option value=""></Option>
                </Select>
              </Form.Item>
            </Col>

            {customFields.map((field) => {
              // Dropdown-type custom fields now define their choices in
              // Settings > People > Custom Field (field_options, a
              // JSON-stringified array) - parse them here to populate the
              // Select. A dropdown with no options defined (legacy data,
              // or the option list was never filled in) still can't be
              // required, same reasoning as before: it would silently
              // block every Create/Edit submission with no way to satisfy it.
              let dropdownChoices = [];
              if (field.field_type === "dropdown") {
                try {
                  const parsed = field.field_options
                    ? JSON.parse(field.field_options)
                    : [];
                  dropdownChoices = Array.isArray(parsed) ? parsed : [];
                } catch (error) {
                  dropdownChoices = [];
                }
              }

              return (
                <Col xl={12} sm={24} key={field.field_id}>
                  <Form.Item
                    className="text-left"
                    name={`custom_${field.field_id}`}
                    label={field.field_name}
                    valuePropName={field.field_type === "checkbox" ? "checked" : "value"}
                    rules={
                      field.field_type === "dropdown" && dropdownChoices.length === 0
                        ? []
                        : [
                            {
                              required: !!field.mandatory,
                              message: `Please provide ${field.field_name}`,
                            },
                          ]
                    }
                  >
                    {field.field_type === "checkbox" ? (
                      <Checkbox />
                    ) : field.field_type === "date" ? (
                      <DatePicker style={{ width: "100%" }} />
                    ) : field.field_type === "dropdown" ? (
                      <Select placeholder="" allowClear>
                        {dropdownChoices.map((choice) => (
                          <Option key={choice} value={choice}>
                            {choice}
                          </Option>
                        ))}
                      </Select>
                    ) : (
                      <Input />
                    )}
                  </Form.Item>
                </Col>
              );
            })}

            {console?.log("document--->", form.getFieldValue("document"))}

            <Col xl={12} sm={24}>
              <Form.Item
                className="text-left"
                name="document"
                label="Upload Document"
                // Not actually enforceable: Upload never wires a value into
                // this Form.Item without additional plumbing
                // (getValueFromEvent), so a `required` rule here blocked
                // every single submission, create or edit.
              >
                <Upload
                  beforeUpload={() => false}
                  maxCount={1}
                  multiple={false}
                  accept="application/msword, application/pdf, .doc, .docx, .pdf"
                  // className="document_uploader w-[100]"
                   className="document_uploader"
                >
                  <Button
                    className="Click_to_Upload "
                    icon={<UploadOutlined />}
                  >
                    Click to Upload
                  </Button>
                </Upload>
              </Form.Item>
            </Col>
            <Col className="checkbox_container_dynamicvalue" xl={12} sm={24}>
              <div className="checkbox_container">
                <Form.Item
                  className="Exclude_from_all"
                  name="Activeagreement"
                  valuePropName="checked"
                  style={{ marginBottom: "" }}
                >
                  <Checkbox>Active</Checkbox>
                </Form.Item>
              </div>
            </Col>

            <Col xl={Object.keys(employeeDetails).length ? 4 : 12} sm={24}>
              <div className="checkbox_container">
                <Form.Item
                  name="Deactivateagreement"
                  valuePropName="checked"
                  style={{ marginBottom: "" }}
                  className="Exclude_from_all"
                >
                  <Checkbox className="people_add_checkbox" onChange={onChange}>
                    Deactivate at
                  </Checkbox>
                </Form.Item>
              </div>
            </Col>

            <Col xl={12} sm={24}>
              <div className="checkbox_container">
                <Form.Item
                  className="Exclude_from_all"
                  name="Excludenotifications"
                  valuePropName="checked"
                  style={{ marginBottom: "" }}
                >
                  <Checkbox onChange={onChange}>
                    Exclude from all notifications and email
                  </Checkbox>
                </Form.Item>
              </div>
            </Col>
          
          <Col xl={24} sm={12} xs={24}>
            <div className="btn_for_create_container">
              <Button
                type="default"
                className="cancel__btn"
                onClick={() => navigate("/people")}
              >
                Cancel
              </Button>
              <Button
                className="cancel_create_btn"
                htmlType="submit"
                type="primary"
              >
                {isEditMode ? "Save" : "Create"}
              </Button>
            </div>
          </Col>
      
          </Row>

        </Form>
      </Uploadcontainer>
      <Uploadcontainer>
      
      </Uploadcontainer>
    </>
  );
};

export default Createformpeople;
